export default __webpack_public_path__ + "static/logo-14b6a1654528709693e9efb0290be919.svg";